module.exports = __webpack_public_path__ + "img/q13.849a1344.jpeg";